module.exports = __webpack_public_path__ + "img/481.e722aa3c.png";